import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation updateDirectory($id: ID!, $model: UpdateDirectoryInput!) {
  updateDirectory(id: $id, input: $model) {
    id
    name
    description
    teams {
      id
      name
    }
    allTeamsOn
  }
}`;

function updateDirectory(id, model) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
      model,
    },
  }).then((res) => res.data.updateDirectory);
}

export default updateDirectory;
